// extracted by mini-css-extract-plugin
module.exports = {"Container":"NoteEditor_Container__2K5on","ActionsContainer":"NoteEditor_ActionsContainer__EtMYK","EditingArea":"NoteEditor_EditingArea__2du2Z"};